module.exports = __webpack_public_path__ + "static/media/lock.46782a6e.svg";